export function getFilterDomainLectures(state) {
  return state.filterDomainLectures;
}

export function getFilterDomainLecturesPosition(state) {
  return state.filterDomainLecturesPosition;
}

export function getLearningElements(state) {
  return state.learningElement;
}



// WEBPACK FOOTER //
// ./src/app/domain-lecture/store/getters.js